import { render, staticRenderFns } from "./ThreesidesLogo.vue?vue&type=template&id=fa1ea90c&"
import script from "./ThreesidesLogo.vue?vue&type=script&lang=ts&"
export * from "./ThreesidesLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports